import { createContext, useContext } from "react";

// The signed-in admin. role "admin" = owner (everything); role "staff" = sub-admin limited to `permissions`.
export const MeContext = createContext({ role: "admin", permissions: [] });
export const canDo = (me, area) => !area || me.role === "admin" || (area !== "owner" && (me.permissions || []).includes(area));
export const useCan = () => { const me = useContext(MeContext); return (area) => canDo(me, area); };
